export const setVersionDesign = (isV2: boolean) => {
  window.localStorage.setItem('is_salesmsg_version_design', isV2 ? 'v2' : 'v1')
}

export const getVersionDesign = () => {
  const value = window.localStorage.getItem('is_salesmsg_version_design')

  if (!value) return 'v1'

  return value
}
